import { Tab, Tabs } from '@material-ui/core';
import BusinessRoutePath from 'app/business-app/BusinessRoutePath';
import styledMixins from 'app/styles/styledMixins';
import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { useHistory } from 'react-router-dom';
import {
  useNotification,
  useSetRepairersActivity,
} from 'app/core/api/company/api-company';
import { useEffectOnce } from 'app/tools/hooks/misc-hooks';
import { PageDetails } from 'app/core/api/company/api-company.types';
import ChatInfo from './ChatInfo';
import CalendarInfo from './CalendarInfo';

const NotificationTabs = styled(Tabs)`
  ${styledMixins.softShadow}
`;

export default function Notifications(): JSX.Element {
  const [activeTab, setActiveTab] = useState(0);
  const onTabChange = (val: unknown) => {
    setActiveTab(val as number);
  };

  const { request$: repairActivity } = useSetRepairersActivity();
  useEffectOnce(() => {
    const pageDetails: PageDetails = {
      pagename: 'Notifications',
    };
    repairActivity(pageDetails).subscribe();
  });
  const history = useHistory();
  const onItemSelect = () => {
    history.push(`${BusinessRoutePath.NOTIFICATIONS}`);
  };
  const { resource: notifications } = useNotification();

  return (
    <>
      <NotificationTabs
        onClick={onItemSelect}
        value={activeTab}
        onChange={(e, val) => onTabChange(val)}
        variant="fullWidth"
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab value={0} label="Calendar" />
        <Tab value={1} label="Chats" />
      </NotificationTabs>

      {activeTab === 0 ? (
        <>
          <h3 style={{ color: '#31AD31', fontWeight: 500 }}>
            Calendar
          </h3>
          {notifications &&
            notifications?.calenderData?.length > 0 && (
              <CalendarInfo data={notifications.calenderData} />
            )}
        </>
      ) : (
        <>
          <h3 style={{ color: '#31AD31', fontWeight: 500 }}>Chats</h3>
          {notifications && notifications?.chatData?.length > 0 && (
            <ChatInfo data={notifications.chatData} />
          )}
        </>
      )}
      {activeTab === 1 ? (
        <>
          <h3 style={{ color: '#31AD31', fontWeight: 500 }}>
            Calendar
          </h3>
          {notifications &&
            notifications?.calenderData?.length > 0 && (
              <CalendarInfo data={notifications.calenderData} />
            )}
        </>
      ) : (
        <>
          <h3 style={{ color: '#31AD31', fontWeight: 500 }}>Chats</h3>

          {notifications && notifications?.chatData?.length > 0 && (
            <ChatInfo data={notifications.chatData} />
          )}
        </>
      )}
    </>
  );
}
